import styled from "styled-components";
import { useT } from "react-polyglot-hooks";
import * as PropTypes from "prop-types";
import { Container } from "../../../components/styled/Grid";
import Typography from "../../../components/styled/Typography";
import { SecondaryButton } from "../../../components/styled/Buttons/SecondaryButton";

const Wrapper = styled.div`
    margin-bottom: 5px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;

    @media ${({ theme }) => theme.breakpoints.md} {
        margin-bottom: 25px;
        gap: 20px;
    }
`;

const StyledButton = styled(SecondaryButton)`
    margin: 0;
    border-radius: 8px !important;
    white-space: normal;
    min-width: 135px;
    max-width: 300px;
    min-height: 60px;
    padding: 5px 10px;
    font-size: clamp(12px, 2vw, 16px);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.2;
    flex: 1 1 40%;
    
    @media ${({ theme }) => theme.breakpoints.md} {
        margin: 25px 0 0;
        flex: initial;
        min-width: 200px;
        font-size: 14px;
        height: 65px;
        padding: 10px 20px;
    }
`;

export default function ListLandings({ landingsList }) {
  const t = useT();

  const renderTags = (pages) =>
    pages.map((page) => (
      <a key={page.slug} href={`/es/${page.slug}`} rel="noopener noreferrer">
        <StyledButton size="lg" border>
          {page.page_category_title}
        </StyledButton>
      </a>
    ));

  return (
    <Container bottom={25} top={25}>
      {landingsList.map((landing) => (
        <div key={landing.key}>
          <Typography
            variant="title2"
            weight="medium"
            css="margin-top: 1%; margin-bottom: 1%"
            center
            space
          >
            {t(`common.${landing.key}`)}
          </Typography>
          <Wrapper>{renderTags(landing.value)}</Wrapper>
        </div>
      ))}
    </Container>
  );
}

ListLandings.defaultProps = {
  landingsList: []
};

ListLandings.propTypes = {
  landingsList: PropTypes.array
};
